<template>
  <div class="life-notice">
    <div class="life-notice-title">充值须知</div>
    <div class="life-notice-list">
      <div class="life-notice-item">1.请仔细核对账号与金额。</div>
      <div class="life-notice-item">2.过期的电费、网费账单请先到门店缴清，如您的订单显示成功，运营商将自动将您的缴费款项计入下一个账单。</div>
      <div class="life-notice-item">3.若对订单有疑问或充值遇到问题，可联系在线客服（在线时间：周一至周五 9:00-18:00）</div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    }
  }
</script>

<style lang="less" scoped>
  .life-notice {
    .life-notice-title {
      font-size: 18px;
      color: #686777;
      font-weight: 600;
      line-height: 27px;
      margin-bottom: 10px;
    }
    .life-notice-list {
      text-align: left;

      .life-notice-item {
        font-size: 12px;
        color: #686777;
        font-weight: 500;
        line-height: 20px;
        margin-bottom: 18px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/life-notice.vue